/* eslint-disable no-return-assign */
/**
 * 聊天会话左侧功能合并组件
 * @author sunzhiguang
 * @date 2020/6/16
 */

import React, { useCallback, useEffect, useState, useRef, useMemo } from "react";
import MsgNotification from "@/components/chat/MsgNotification";
import SessionTop from "@/components/chat/SessionTop";
import ChatState, { UserState } from "@/types/chat/State";
import GlobalSearch from "@/components/GlobalSearch";
import { SessionProps } from "@/types/chat";
import { connect } from "dva";
import "./index.less";
import SessionList, { sessionItem } from "@/components/chat/SessionList";
import bus from "@/utils/bus";
import Loading from "@/components/Loading";
import MigrateTip from "@/components/ErrorHolder/MigrateTip";
import PromptTip from "@/components/ErrorHolder/promptTip";
import ScrollView from "@/baseComponents/ScrollView";
import { throttle } from "lodash";
import { useTranslation } from "react-i18next";
import { FocusSDK } from "@/utils"; 
// import RowGrid from "./newComp/RowGridUseGridDnd/index2";
import { RowGrid } from "@jd/focus-desktop-comps";
import TopUpSession from "./newComp/TopUpSession";
import StatusTip from "@/components/ErrorHolder/StatusTip";
import { SessionSettingService } from "@/server/im/SessionService";
import ImService from "@/server/ImService";
import { handleTopSessionSort } from "@/components/chat/Session/common";
import { isAINoticeSession } from "@/utils/chat/session";
import { Badge } from "@jd/focus-desktop-comps";
import IconFont from "@/components/icon";
import {
  isShieldSession
} from "@/utils/chat/message";

interface dvaProps {
  reSortAllSessionList: Function;
  getAllChatSessions: Function;
  updatePageLoadState: Function;
  setTopUpExpanded: (expanded: boolean) => void;
}

type IChatLeftProps = Readonly<ChatState & UserState & dvaProps>;

function ChatLeft(this: any, props: IChatLeftProps) {
  const [showSessionTopAll, setShowSessionTopAll] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const PAGE_SIZE = 20;
  const pageSize = useRef(PAGE_SIZE);
  const {
    sessionStatusMap,
    allSessionList,
    reSortAllSessionList,
    getAllChatSessions,
    loadAllSessionListEnd,
    sessionLoadEnd,
    sessionPage,
    showSyncMsgTip,
    topUpSessionList,
    topUpModeCustom, // 置顶布局模式，默认水平布局
    topUpExpanded,
    setTopUpExpanded,
    aiNoticeSessionList
  } = props;
  const { t } = useTranslation("chat");

  // const [withBtnPopover, setWithBtnPopover] = useState<boolean>(true);
  // console.log('leftSide', allSessionList);
  useEffect(() => {
    // console.log('allSessionList', allSessionList);
    // 这个变更需要重新排序 allSessionList
    const list = allSessionList.map((item) => {
      const data = sessionStatusMap[item.sessionId];
      if (data && data.timestamp > item.timestamp && data.info.content) {
        return Object.assign(item, { timestamp: data.timestamp });
      }
      return item;
    });
    reSortAllSessionList({ allSessionList: list });
  }, [sessionStatusMap]); // eslint-disable-line

  // useEffect(() => {
  //     bus.on('hideGlobalSearchModel', () => {
  //         setWithBtnPopover(true);
  //     });
  //     bus.on('showGlobalSearchModel', () => {
  //         setWithBtnPopover(false);
  //     });
  //     return () => {
  //         bus.off('showGlobalSearchModel');
  //         bus.off('hideGlobalSearchModel');
  //     };
  // }, []);

  const scrollRef = useRef(null);

  const closeAllFollow = useCallback(() => {
    setShowSessionTopAll(false);
  }, []);

  // 屏幕大小调整加载条数
  const handleResize = useCallback(() => {
    const curr: any = scrollRef.current;
    if (!curr) {
      return;
    }
    const count = Math.ceil(curr.getClientHeight() / sessionItem.height);
    pageSize.current = Math.max(count, PAGE_SIZE);
  }, []);
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onScroll = async () => {
    const curr: any = scrollRef.current;
    const mask: any = document.getElementById("chat-left-mask");
    if (!curr) {
      return;
    }
    mask.style.display = "none";
    const { scrollHeight, scrollTop, clientHeight } = curr.getValues();
    // if (!sessionLoadEnd && scrollTop !== 0 && clientHeight + scrollTop > scrollHeight - 180) {
    if (!sessionLoadEnd && scrollTop !== 0 && scrollTop > (scrollHeight - clientHeight) / 2) {
      getAllChatSessions({
        options: {
          offset: sessionPage * pageSize.current,
          count: pageSize.current
        }
      });
    }
  };

  const getSortedTopSessionList = () => {
    if (!allSessionList || (allSessionList || []).length === 0) {
      return [];
    }

    const result = allSessionList
      ?.filter((item: SessionProps) => (item?.settings?.top || 0) > 0)
      .sort((a, b) => {
        return (b.settings.topOrder || 0) - (a.settings.topOrder || 0);
      });
    // 获取ai助手的未读消息数
    result.forEach((item) => {
      if (isAINoticeSession(item)) {
        let unreadCount = 0;
        aiNoticeSessionList.forEach((item) => {
          if (item?.settings?.shield !== 1) {
            unreadCount += item.unreadCount || 0;
          }
        });
        item.unreadCount = unreadCount || 0;
      }
    });
    console.log(
      "getAllSessionList===getSortedTopSessionList",
      result
      // .map(i => {
      //   return {
      //     name: i.info.name,
      //     sessionId: i.sessionId,
      //     del: i.del,
      //     settings: i.settings,
      //     timestamp: i.timestamp,
      //     lastMsg: i.lastMsg
      //   }
      // })
    );
    return result;
  };

  const setTopUpSessionList = async (sortedSessionList: SessionProps[]) => {
    // getSortedTopSessionList();
    console.log("getAllSessionList===排序后的列表", sortedSessionList);
    const result = await handleTopSessionSort({
      sessionId: sortedSessionList[0].sessionId,
      sortedSessionList
    });
  };

  return (
    <div className="chat-left-container">
      {/* 消息类型切换部分 */}
      {/* <Search withBtnPopover={true} /> */}
      <StatusTip
        showSyncMsgTip={showSyncMsgTip}
        showSessionTopAll={showSessionTopAll}
        isAllFollow={showSessionTopAll}
        closeAllFollow={closeAllFollow}
      />
      <MigrateTip />
      <PromptTip />
      {/* xly-新增置顶头像展示区 */}
      {topUpModeCustom === "horizon" && <RowGrid
        items={getSortedTopSessionList()}
        itemWidth={53}
        maxUnExpendRow={2}
        expanded={topUpExpanded}
        onExpandChange={setTopUpExpanded} 
        onSort={setTopUpSessionList} // 你需要维护排序后的数据
        getKey={item => item.sessionId}
        renderItem={(item) => (
          <TopUpSession
            session={item}
            key={item.sessionId}
            last={false}
          />
        )}
        // 自定义展开按钮上的角标展示规则
        getNumPiecesPartFunction={((unexpandSessions: any) => {
          if (unexpandSessions.length === 0) return null;
          const hasAt = unexpandSessions.find((item: any) => item?.mentions && Object.values(item.mentions).length > 0)
          if (hasAt) {
            return <Badge style={{ right: 10, top: 10, fontSize: 16 }} className="badge-top-right" icon={<IconFont type="icontiji1" />} />
          } else {
            // 判断是否只有免打扰会话
            console.log("unexpandSessions:", unexpandSessions);
            const unexpandSessionsWithUnread = unexpandSessions.filter((item: any) => item.unreadCount > 0);
            const onlyShieldSessions = unexpandSessionsWithUnread.length > 0 && unexpandSessionsWithUnread.every((item: any) => isShieldSession(item));
            if (onlyShieldSessions) {
              return <Badge dot style={{ right: 10, top: 8 }} className="badge-top-right" />;
            } else {
              const unReadCount = unexpandSessions
                .filter((item: any) => !isShieldSession(item))
                .reduce((sum: any, item: any) => sum + (item.unreadCount || 0), 0);
              // const unReadCount = 100;
              return <Badge style={{ right: 10, top: 10 }} className="badge-top-right" value={unReadCount} />
            }
          }
        })}
      />}
      {/* 头部消息类型 */}
      {/* 头部消息中的状态提示并入StatusTip组件 */}
      <MsgNotification
        showSessionTopAll={showSessionTopAll}
        isAllFollow={showSessionTopAll}
        closeAllFollow={closeAllFollow}
      />
      {/* 同步通知并入StatusTip组件 */}
      {/* {showSyncMsgTip && <div className="sync-msg-tip">{t("message is syncchronizing")}</div>} */}
      {loadAllSessionListEnd ? (
        <ScrollView
          className="chat-left-scroll reply-popover scroll-view"
          id="chat-left-scroll"
          ref={scrollRef}
          onScroll={throttle(onScroll, 300)}
          nohorizontal="true"
          newLayout={true}
        >
          <div className="chat-left-mask" id="chat-left-mask" />
          {topUpModeCustom === "horizon" && (
            <SessionList
              topUpModeCustom="horizon"
              allSessionList={allSessionList}
              showSessionTopAll={showSessionTopAll}
            />
          )}
          {topUpModeCustom === "vertical" && (
            <SessionList
              topUpModeCustom="vertical"
              allSessionList={allSessionList}
              showSessionTopAll={showSessionTopAll}
            />
          )}
        </ScrollView>
      ) : (
        <div className="chat-left-scroll reply-popover scroll-view" id="chat-left-scroll">
          <Loading />
        </div>
      )}
    </div>
  );
}

function mapStateToProps({ chat, user }: any) {
  const {
    connectState,
    sessionStatusMap,
    allSessionList,
    loadAllSessionListEnd,
    sessionLoadEnd,
    sessionPage,
    showSyncMsgTip,
    topUpSessionList,
    topUpExpanded,
    aiNoticeSessionList
  } = chat as ChatState;
  return {
    connectState,
    sessionStatusMap,
    allSessionList,
    loadAllSessionListEnd,
    sessionLoadEnd,
    sessionPage,
    showSyncMsgTip,
    topUpSessionList,
    topUpModeCustom: user.topUpModeCustom,
    topUpExpanded,
    aiNoticeSessionList
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    async reSortAllSessionList(data: { allSessionList: SessionProps[] }) {
      await dispatch({ type: "chat/reSortAllSessionList", payload: data });
    },
    getAllChatSessions(data: any) {
      dispatch({ type: "chat/getAllChatSessions", payload: data });
    },
    setTopUpExpanded(data: any) {
      dispatch({ type: "chat/setTopUpExpanded", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatLeft);
